export default function ShadedMatrix({
  xs,
  ys,
  xLabel,
  yLabel,
  points,
  minVal,
  maxVal,
  decimals,
  invertOpacity = false,
}) {
  let range = maxVal - minVal;
  return (
    <div className="shaded-matrix-container">
      <div className="matrix-y-label">{yLabel}</div>
      <div className="shaded-matrix">
        <div style={{ justifyContent: "center" }} className="matrix-row">
          {xLabel}
        </div>
        <div className="matrix-row">
          <div
            style={{ height: "2vw", width: "2vw" }}
            className="matrix-cell label"
          ></div>
          {xs.map((x) => (
            <div style={{ height: "2vw" }} className="matrix-cell label">
              {x}
            </div>
          ))}
        </div>
        {ys.map((y) => (
          <div className="matrix-row">
            <div style={{ width: "2vw" }} className={"matrix-cell label"}>
              {y}
            </div>
            {xs.map((x) => {
              let x_point = points[x];
              var point;
              var opacity;
              if (x_point !== undefined) {
                point = x_point[y];
              } else {
                point = undefined;
              }
              if (point === undefined) {
                return <div className={"matrix-cell blank"}></div>;
              } else if (point === null) {
                opacity = 0;
                return (
                  <div
                    style={{
                      backgroundColor: `rgba(184, 224, 218, ${opacity})`,
                    }}
                    className="matrix-cell shaded"
                  >
                    -
                  </div>
                );
              } else {
                opacity = (point - minVal) / range;
                if (invertOpacity) {
                  opacity = 1 - opacity;
                }
              }
              return (
                <div
                  style={{ backgroundColor: `rgba(184, 224, 218, ${opacity})` }}
                  className="matrix-cell shaded"
                >
                  {point.toFixed(decimals)}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
